import req from "../utils/axios"

class BaseAPI {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  get(endpoint, useToken = false) {
    return req({
      useToken: useToken,
      url: this.baseUrl ? `${this.baseUrl}${endpoint}` : endpoint,
      method: "get",
    })
  }

  getByQuery(endpoint, query, useToken = false) {
    return req({
      useToken: useToken,
      url: this.baseUrl ? `${this.baseUrl}${endpoint}` : endpoint,
      method: "get",
      params: query
    })
  }

  getByParams(endpoint, query, useToken = false) {
    return req({
      useToken: useToken,
      url: this.baseUrl ? `${this.baseUrl}${endpoint}` : endpoint,
      method: "get",
      params: query
    })
  }

  post(endpoint, data, useToken = false) {
    return req({
      useToken: useToken,
      url: this.baseUrl ? `${this.baseUrl}${endpoint}` : endpoint,
      method: "post",
      data
    })
  }

  postByQuery(endpoint, query, useToken = false) {
    return req({
      useToken: useToken,
      url: this.baseUrl ? `${this.baseUrl}${endpoint}` : endpoint,
      method: "post",
      params: query
    })
  }

  postByParam(endpoint, useToken = false) {
    return req({
      useToken: useToken,
      url: this.baseUrl ? `${this.baseUrl}${endpoint}` : endpoint,
      method: "post",
    })
  }

  put(endpoint, data, useToken = false) {
    return req({
      useToken: useToken,
      url: this.baseUrl ? `${this.baseUrl}${endpoint}` : endpoint,
      method: "put",
      data
    })
  }

  patch(endpoint, data, useToken = false) {
    return req({
      useToken: useToken,
      url: this.baseUrl ? `${this.baseUrl}${endpoint}` : endpoint,
      method: "patch",
      data
    })
  }

  patchByQuery(endpoint, query, useToken = false) {
    return req({
      useToken: useToken,
      url: this.baseUrl ? `${this.baseUrl}${endpoint}` : endpoint,
      method: "patch",
      params: query
    })
  }

  delete(endpoint, useToken = false) {
    return req({
      useToken: useToken,
      url: this.baseUrl ? `${this.baseUrl}${endpoint}` : endpoint,
      method: "delete",
    })
  }

  deleteByQuery(endpoint, query, useToken = false) {
    return req({
      useToken: useToken,
      url: this.baseUrl ? `${this.baseUrl}${endpoint}` : endpoint,
      method: "delete",
      params: query
    })
  }
}

export { BaseAPI as default }